// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610191535/js/" + chunkId + "." + {"44":"8c6da728","225":"8c8d472f","481":"8fd48125","486":"49478bc0","770":"bf4994f1"}[chunkId] + ".0.7043411410683218.chunk.js";
};